import React, { useState, useRef } from 'react';
import { Text } from '../../components/Text';
import Input from './Input';
import Messages from './Messages';
import { changeIsUserSelected } from '../../reducers/telegram/telegram-slice';
import { useDispatch, useSelector } from 'react-redux';
import { CustomButton } from '../../components/CustomButton';
import MediaFileView from './MediaFileView';
import CopyToClipboard from '../../components/CopyToClipboard';
import EmptyChatState from '../../components/EmptyChatState/EmptyChatState';

// import MediaFileView from './MediaFileView';

const ChatDetails = () => {
  const dispatch = useDispatch();

  const { selectedContact } = useSelector((state) => state.telegram);
  const [fileselected, setFileselected] = useState(null);

  function ChatHeader() {
    return (
      <div className="flex align-items-center gap-1 ">
        <CustomButton
          varient="icon-button md:hidden"
          icon={'pi pi-arrow-left'}
          onClick={() => dispatch(changeIsUserSelected(false))}
        />

        <Text type="sub-heading" cust="flex align-items-center">
          <div className="capitalize mr-3">
            <Text type={'sub-heading'}>{selectedContact?.telegramName}</Text>
          </div>
          <div>
            {selectedContact?.telegramName && (
              <CopyToClipboard toClipboard={selectedContact?.telegramName} />
            )}
          </div>
        </Text>
      </div>
    );
  }

  if (!selectedContact) {
    return (
      <div className="h-full">
        <EmptyChatState />
      </div>
    );
  }
  return (
    <div className="h-full">
      <div className="flex flex-column h-full ">
        {Object.keys(selectedContact)?.length != 0 && (
          <>
            <div className="chatInfo p-2">
              <div className="w-auto">{ChatHeader()}</div>
            </div>
            {fileselected ? (
              <MediaFileView file={fileselected} setFileselected={setFileselected} />
            ) : (
              <>
                <Messages />
                <Input setFileselected={setFileselected} />
              </>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default ChatDetails;
